import { z } from 'zod';

const envSchema = z.object({
  VITE_STAGE: z.string().min(1),
  VITE_API_BASE_URL: z.string().url(),
  VITE_AUTH_BASE_URL: z.string().url(),
  VITE_CLIENT_ID: z.string().min(1),
  VITE_REDIRECT_URL: z.string().url(),
  VITE_WSS_URL: z.string().min(1),
  VITE_SERVICE_LOGIN: z.string().url(),
  VITE_SERVICE_REACH: z.string().url(),
  VITE_SERVICE_ACCOUNT: z.string().url(),
  VITE_SERVICE_REG: z.string().url(),
  VITE_SERVICE_PLM: z.string().url(),
  VITE_SERVICE_CAM: z.string().url(),
  VITE_SERVICE_ADMIN: z.string().min(1),
});

export type Env = z.infer<typeof envSchema>;

let cachedEnv: Env | null = null;

export function validateEnv(): Env {
  if (cachedEnv) return cachedEnv;

  const result = envSchema.safeParse(import.meta.env);

  if (!result.success) {
    const errors = result.error.flatten().fieldErrors;
    const missing = Object.entries(errors)
      .map(([key, msgs]) => `  ${key}: ${msgs?.join(', ')}`)
      .join('\n');

    throw new Error(
      `Invalid environment variables:\n${missing}\n\n` +
        `Check your .env files or run with the correct --mode flag.\n` +
        `Available modes: testing, staging, live`,
    );
  }

  cachedEnv = result.data;
  return cachedEnv;
}
